import {
  useBaseButtonProps
} from "./chunk-VY7Q4TTP.mjs";
import {
  BaseButton
} from "./chunk-OUK7C65F.mjs";
import {
  buttonVariants
} from "./chunk-DO5M4NPD.mjs";
import {
  Loading
} from "./chunk-C6PXTYLO.mjs";

// src/button/src/button.tsx
import * as React from "react";
import { cx } from "class-variance-authority";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var commonIconClassnames = "inline-flex shrink-0 self-center [&_svg]:h-6 [&_svg]:w-6";
var Button = React.forwardRef(
  (props, forwardedRef) => {
    const {
      as = "button",
      busy = false,
      busyLabel,
      children,
      destructive = false,
      disabled = false,
      endIcon,
      fullWidth = false,
      startIcon,
      variant = "primary"
    } = props;
    const buttonProps = useBaseButtonProps({
      ...props,
      ref: forwardedRef
    });
    return /* @__PURE__ */ jsx(
      BaseButton,
      {
        as,
        className: buttonVariants({
          busy,
          destructive,
          disabled,
          fullWidth,
          variant
        }),
        ...buttonProps,
        children: /* @__PURE__ */ jsx("span", { className: "flex h-full items-center overflow-hidden whitespace-nowrap", children: busy === true ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              className: cx(commonIconClassnames, "[&_svg]:animate-spin"),
              children: /* @__PURE__ */ jsx(Loading, {})
            }
          ),
          Boolean(busyLabel) && /* @__PURE__ */ jsx("span", { className: "ml-2", children: busyLabel })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          Boolean(startIcon) && /* @__PURE__ */ jsx("span", { className: cx(commonIconClassnames, "mr-2"), children: startIcon }),
          children,
          Boolean(endIcon) && /* @__PURE__ */ jsx("span", { className: cx(commonIconClassnames, "ml-2"), children: endIcon })
        ] }) })
      }
    );
  }
);

export {
  Button
};
